module.exports = __webpack_public_path__ + "static/media/LXGWWenKai-Regular.decce069.ttf";